import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import setting from './modules/setting'
import pageHistory from '@/store/modules/page-history'
import cacheRequest from '@/store/modules/cache-request'
import aliveRouter from '@/store/modules/alive-router'

// default router permission control
// import permission from './modules/permission'
// dynamic router permission control (Experimental)
import permission from './modules/async-router'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    setting,
    pageHistory,
    cacheRequest,
    aliveRouter
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
